import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Students from "@/pages/Students";
import Parents from "@/pages/Parents";
import Teachers from "@/pages/Teachers";
import BEP from "@/pages/BEP";
import Notes from "@/pages/Notes";
import Tasks from "@/pages/Tasks";
import ActivityPool from "@/pages/ActivityPool";
import Feedback from "@/pages/Feedback";
import Pools from "@/pages/Pools";
import SiteSettings from "@/pages/SiteSettings";
import AiReports from "@/pages/AiReports";
import Roles from "@/pages/Roles";
import Packages from "@/pages/Packages";
import Pages from "@/pages/Pages";
import PublicPage from "@/pages/PublicPage";
import Landing from "@/pages/Landing";
import ParentLogin from "@/pages/ParentLogin";
import ParentPortal from "@/pages/ParentPortal";
import { Toaster } from "@/components/ui/sonner";

const STAFF = ["super_admin", "institution_admin", "teacher"];

function Page({ permission, children }) {
  return (
    <ProtectedRoute roles={STAFF} permission={permission}>
      {children}
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/adminxx1" element={<Login />} />
            <Route path="/adminxx1/dashboard" element={<Page permission="dashboard"><Dashboard /></Page>} />
            <Route path="/adminxx1/profile" element={<ProtectedRoute roles={STAFF}><Profile /></ProtectedRoute>} />
            <Route path="/adminxx1/students" element={<Page permission="students"><Students /></Page>} />
            <Route path="/adminxx1/parents" element={<Page permission="parents"><Parents /></Page>} />
            <Route path="/adminxx1/teachers" element={<Page permission="teachers"><Teachers /></Page>} />
            <Route path="/adminxx1/bep" element={<Page permission="bep"><BEP /></Page>} />
            <Route path="/adminxx1/notes" element={<Page permission="notes"><Notes /></Page>} />
            <Route path="/adminxx1/tasks" element={<Page permission="tasks"><Tasks /></Page>} />
            <Route path="/adminxx1/activity-pool" element={<Page permission="activity_pool"><ActivityPool /></Page>} />
            <Route path="/adminxx1/feedback" element={<Page permission="feedback"><Feedback /></Page>} />
            <Route path="/adminxx1/pools" element={<Page permission="pools"><Pools /></Page>} />
            <Route path="/adminxx1/settings" element={<Page permission="settings"><SiteSettings /></Page>} />
            <Route path="/adminxx1/pages" element={<Page permission="pages"><Pages /></Page>} />
            <Route path="/adminxx1/ai-reports" element={<Page permission="ai_reports"><AiReports /></Page>} />
            <Route path="/adminxx1/roles" element={<Page permission="roles"><Roles /></Page>} />
            <Route path="/adminxx1/packages" element={<Page permission="packages"><Packages /></Page>} />

            <Route path="/login" element={<ParentLogin />} />
            <Route path="/veli" element={<ProtectedRoute roles={["parent"]} redirectTo="/login"><ParentPortal /></ProtectedRoute>} />

            <Route path="/sayfa/:slug" element={<PublicPage />} />
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
